import React from "react";
import { string, object, func } from "prop-types";
import { Row, Dropdown } from "react-bootstrap";
import { getScoreRangeDropdownItems } from "./TestReports/RawScoreTestReports/rawScoreTestReportHelpers";

const ScoreRangeDropdown = ({
  criteriaScoreRanges,
  customScoreRanges,
  handleScoreRangeSelection,
  scoreRangeName,
}) => (
  <Row className="justify-content-center">
    <Dropdown
      id="dynamicScoreReportsScoreRanges"
      title="Select a Score Range"
      variant="outline-secondary"
      onSelect={handleScoreRangeSelection}
    >
      <Dropdown.Toggle
        className="text-left text-truncate"
        size="lg"
        variant="outline-secondary"
        data-test="addScoreRange"
        style={{ width: "300px" }}
      >
        {scoreRangeName || "Select a Score Range"}
      </Dropdown.Toggle>
      <Dropdown.Menu
        style={{ height: "250px", overflowY: "scroll", width: "100%" }}
        data-test="scoreRangeMenu"
      >
        <Dropdown.Item eventKey="0" key="0">
          No Score Range
        </Dropdown.Item>
        <Dropdown.Divider />
        {criteriaScoreRanges.size > 0 && (
          <Dropdown.Header
            className="font-weight-bold"
            data-test="criteriaScoreRangeHeader"
          >
            Criteria Score Ranges
          </Dropdown.Header>
        )}
        {getScoreRangeDropdownItems(criteriaScoreRanges)}
        {criteriaScoreRanges.size > 0 && customScoreRanges.size > 0 && (
          <Dropdown.Divider />
        )}
        {customScoreRanges.size > 0 && (
          <Dropdown.Header
            className="font-weight-bold"
            data-test="customScoreRangeHeader"
          >
            Custom Score Ranges
          </Dropdown.Header>
        )}
        {getScoreRangeDropdownItems(customScoreRanges, true)}
      </Dropdown.Menu>
    </Dropdown>
  </Row>
);

ScoreRangeDropdown.propTypes = {
  criteriaScoreRanges: object,
  customScoreRanges: object,
  handleScoreRangeSelection: func.isRequired,
  scoreRangeName: string,
};

export default ScoreRangeDropdown;
